import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Header.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef();
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
    window.addEventListener("scroll", handleScroll);

    const handleClickOutside = (event) => {
      if (menuOpen && navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <Link to="/" className="logo-link" onClick={closeMenu}>
        <div className="logo-container">
          <img src="/softblitz-logo.svg" alt="Softblitz Logo" className="logo-img" />
        </div>
      </Link>

      <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        {!menuOpen && <FaBars className="hamburger-icon" />}
      </div>

      <nav ref={navRef} className={`nav ${menuOpen ? "open" : ""}`}>
        <ul>
          <li className="close-icon-wrapper">
            <FaTimes className="close-icon" onClick={closeMenu} />
          </li>
          <li><a href={isHome ? "#home" : "/#home"} onClick={closeMenu}>Home</a></li>
          <li><a href={isHome ? "#services" : "/#services"} onClick={closeMenu}>Services</a></li>
          <li><a href={isHome ? "#technologies" : "/#technologies"} onClick={closeMenu}>Technologies</a></li>
          <li><a href={isHome ? "#about" : "/#about"} onClick={closeMenu}>About Us</a></li>
          <li><Link to="/careers" onClick={closeMenu}>Careers</Link></li>
          <li><a href={isHome ? "#footer" : "/#footer"} onClick={closeMenu}>Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;